import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import FaqList from './FaqList';
import styled from 'styled-components';
import { rem } from 'polished';
import ContactForm from '../../_helpers/Contact/ContactForm';

interface Props {
  faq: any;
  content: any;
  dispatch: (action: any) => void;
}

const FaqContentWrapper = styled.div`
  width: 100%;
`;

const ChatInfoBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${rem(16)};
  background: ${({ theme }) => theme.color.background};
  border-radius: ${({ theme }) => rem(theme.borderRadius.default)};
  padding: ${rem(15)} ${rem(24)};
  margin-bottom: ${rem(20)};
  width: 100%;
`;

const ChatInfoIcon = styled.img`
  width: ${rem(40)};
  height: ${rem(40)};
  flex-shrink: 0;
  margin-top: ${rem(2)};
  filter: invert(13%) sepia(94%) saturate(4844%) hue-rotate(337deg)
    brightness(88%) contrast(103%);
`;

const ChatInfoContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const ChatInfoTitle = styled.h3`
  font-size: ${rem(16)};
  font-weight: 700;
  margin: 0 0 ${rem(4)} 0;
  color: ${({ theme }) => theme.color.text};
`;

const ChatInfoText = styled.p`
  font-size: ${rem(14)};
  margin: 0 0 ${rem(2)} 0;
`;

const ChatButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${rem(8)};
  background: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.text};
  border: ${rem(2)} solid ${({ theme }) => theme.color.gray80};
  border-radius: ${({ theme }) => rem(theme.borderRadius.default)};
  padding: ${rem(4)} ${rem(10)};
  font-size: ${rem(14)};
  cursor: pointer;
  margin-top: ${rem(12)};
  align-self: flex-start;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.color.gray56};
  }
`;

const ChatButtonIcon = styled.img`
  width: ${rem(18)};
  height: ${rem(18)};
  filter: invert(13%) sepia(94%) saturate(4844%) hue-rotate(337deg)
    brightness(88%) contrast(103%);
`;

const Wrapper = styled.div``;

const FormWrapper = styled.div`
  margin-top: ${rem(20)};
`;

const openSmartsuppChat = () => {
  if (
    typeof window !== 'undefined' &&
    typeof (window as any).smartsupp === 'function'
  ) {
    (window as any).smartsupp('chat:open');
  }
};

class Faq extends React.PureComponent<Props> {
  public render() {
    return (
      <Wrapper>
        <ChatInfoBox>
          <ChatInfoIcon
            src="/images/icons/question.svg"
            alt={__('Otázka')}
            loading="lazy"
          />
          <ChatInfoContent>
            <ChatInfoTitle>
              {__('Nenašli ste odpoveď? Spýtajte sa v chate.')}
            </ChatInfoTitle>
            <ChatInfoText>
              {__(
                'Chat je pre rýchle odpovede dostupný v pracovných dňoch od 07:00 - 15:30.',
              )}
            </ChatInfoText>
            <ChatInfoText>
              {__(
                'Otázky kladené mimo pracovný čas budú zodpovedané formou emailu nasledujúci pracovný deň.',
              )}
            </ChatInfoText>
            <ChatButton type="button" onClick={openSmartsuppChat}>
              <ChatButtonIcon src="/images/icons/chat2.svg" alt={__('Chat')} />
              {__('Spustiť chat')}
            </ChatButton>
          </ChatInfoContent>
        </ChatInfoBox>
        <FaqList items={this.props.faq.articles} />
        {this.props.content && typeof this.props.content === 'string' && (
          <FaqContentWrapper>
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.content,
              }}
            />
          </FaqContentWrapper>
        )}
        <FormWrapper>
          <ContactForm dispatch={this.props.dispatch} />
        </FormWrapper>
      </Wrapper>
    );
  }
}

export default Faq;
